import React from 'react';
import { Button as RMWCButton } from '@rmwc/button';
import { CircularProgress } from '@rmwc/circular-progress';
import '@rmwc/button/styles';
import '@rmwc/circular-progress/styles';

export const Button = ({ isLoading, ...rest }) => (
  <RMWCButton icon={isLoading ? <CircularProgress /> : null} {...rest} />
);
